export default __webpack_public_path__ + "static/media/basic-pin-small-9.78cbab57.png";